export default __webpack_public_path__ + "static/noExpired-88d4da31b5b70ba744fe1e3552a3ba10.svg";